import { render, staticRenderFns } from "./tabFclApproveSettings.vue?vue&type=template&id=0d38f7ca&scoped=true&"
import script from "./tabFclApproveSettings.vue?vue&type=script&lang=js&"
export * from "./tabFclApproveSettings.vue?vue&type=script&lang=js&"
import style0 from "./tabFclApproveSettings.vue?vue&type=style&index=0&id=0d38f7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38f7ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d38f7ca')) {
      api.createRecord('0d38f7ca', component.options)
    } else {
      api.reload('0d38f7ca', component.options)
    }
    module.hot.accept("./tabFclApproveSettings.vue?vue&type=template&id=0d38f7ca&scoped=true&", function () {
      api.rerender('0d38f7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFCL/components/PriceFCL/tabFclApproveSettings.vue"
export default component.exports